// extracted by mini-css-extract-plugin
export default {"loading":"loading4_loading__-eh-w","twin-circles":"loading4_twin-circles__5QHjI","moveLeft":"loading4_moveLeft__hl4na","moveRight":"loading4_moveRight__8VYCz"};